import React from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { VideosLayout } from "@/components/videos/VideosLayout";
import { GraduationCap, ArrowRight } from "lucide-react";

export const VideosAcademyPage: React.FC = () => {
  return (
    <VideosLayout>
      <SEOHead
        title="JNN Homes Academy | JNN Homes Northern Virginia"
        description="JNN Homes Academy — step-by-step lessons on preparing, furnishing and caring for a home as a vacation rental. Coming soon."
        canonical="https://www.jnnhomes.com/videos/academy"
      />

      <div className="space-y-8">
        <nav className="flex items-center gap-2 text-xs text-slate-500 font-medium">
          <Link to="/videos" className="hover:text-[#9A5207]">
            Videos
          </Link>
          <span>›</span>
          <span className="text-slate-900 font-semibold">Academy</span>
        </nav>

        <div className="space-y-4">
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            JNN Homes Academy
          </h1>
          <p className="text-sm text-slate-600 max-w-2xl">
            Structured courses that walk you through the whole process of
            turning a home into a guest-ready vacation rental.
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="p-8 rounded-2xl border border-dashed border-slate-300 bg-slate-50/50 text-center space-y-5">
          <div className="inline-flex p-4 rounded-2xl bg-[#E8850F]/14 text-[#9A5207]">
            <GraduationCap className="w-10 h-10" />
          </div>
          <div className="space-y-2">
            <div className="inline-flex items-center gap-2">
              <h2 className="text-xl font-bold text-slate-900">Coming soon</h2>
              <span className="px-2 py-0.5 text-[10px] font-bold uppercase rounded bg-amber-100 text-amber-700">
                In production
              </span>
            </div>
            <p className="text-sm text-slate-600 max-w-md mx-auto">
              We're putting together step-by-step lessons on preparing,
              furnishing and caring for a home as a vacation rental.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
            <a
              href="https://www.youtube.com/@JNNHomes?sub_confirmation=1"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 rounded-xl bg-slate-900 text-white font-bold text-xs hover:bg-slate-800 transition-colors shadow-sm focus:outline-none focus:ring-2 focus:ring-[#D97706]"
            >
              Subscribe on YouTube
            </a>
            <Link
              to="/videos/playlists"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-xl border border-slate-200 bg-white text-slate-900 font-bold text-xs hover:border-[#E8850F] hover:text-[#9A5207] transition-colors shadow-xs"
            >
              Browse current playlists <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </VideosLayout>
  );
};
